import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mysteryBoxSizes } from '~/shared/utils/mysteryBoxSizes';
import { mobile } from '~/techstyle-shared/react-components';

const SelectorList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  gap: 6px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  ${mobile`
      grid-template-columns: 1fr 1fr 1fr;
      padding: 16px;
    `}
`;

const SelectorItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 40px;
  width: 100%;
  cursor: pointer;
`;

const SelectorRadioButton = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  opacity: 0;
`;

const SelectorItemLabel = styled.label`
  font-size: 16px;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.palette.shadow25};

  ${SelectorRadioButton}:checked + & {
    border: 3px solid black;
  }
`;

function GroupSizeSelector({ product }) {
  const maleTagId = config.get('public.productTags.maleTagId');
  const isMaleProduct = product?.tagIdList?.includes(maleTagId);
  const sizes = isMaleProduct
    ? Object.keys(mysteryBoxSizes.M.default)
    : Object.keys(mysteryBoxSizes.F);

  return (
    <SelectorList>
      {sizes.map((size) => (
        <SelectorItem key={size}>
          <SelectorRadioButton name="size" id={size} value={size} />
          <SelectorItemLabel htmlFor={size}>{size}</SelectorItemLabel>
        </SelectorItem>
      ))}
    </SelectorList>
  );
}

GroupSizeSelector.propTypes = {
  product: PropTypes.object.isRequired,
};

export default GroupSizeSelector;
